import isArray from 'lodash/isArray';
import uniq from 'lodash/uniq';
import type { FollowUpType } from '../reducers';
export const updateFollowUp = (followUp: FollowUpType) => {
  // intentionally not checking empty just make sure it's there
  if (followUp.questionIds) {
    return followUp;
  }
  const newFollowUp = {
    ...followUp
  };
  // @ts-expect-error todo(ts-migration) TS2551 Property 'questionId' does not exist on type '{ conditions: ConditionsType; questionIds: string[]; }'. Did you mean 'questionIds'?
  delete newFollowUp.questionId;
  let newFollowUPQuestionIds;
  // @ts-expect-error todo(ts-migration) TS2551 Property 'questionId' does not exist on type 'FollowUpType'. Did you mean 'questionIds'?
  if (followUp.questionId) {
    // @ts-expect-error todo(ts-migration) TS2551 Property 'questionId' does not exist on type 'FollowUpType'. Did you mean 'questionIds'?
    if (isArray(followUp.questionId)) {
      // @ts-expect-error todo(ts-migration) TS2551 Property 'questionId' does not exist on type 'FollowUpType'. Did you mean 'questionIds'?
      newFollowUPQuestionIds = [...followUp.questionId];
    } else {
      // @ts-expect-error todo(ts-migration) TS2551 Property 'questionId' does not exist on type 'FollowUpType'. Did you mean 'questionIds'?
      newFollowUPQuestionIds = [followUp.questionId];
    }
    newFollowUp.questionIds = uniq(newFollowUPQuestionIds);
  }
  return newFollowUp;
};